// extracted by mini-css-extract-plugin
var _1 = "1166px";
var _2 = "1252px";
export { _1 as "postSidebarShiftBreakpoint", _2 as "rightPanelShiftBreakpoint" }
